import oppiziLogo from '../../../Assets/Images/opp_main_logo.png'

export const styles = {
  wrapper: {
    display: 'flex',
    width: '100%',
  },
  chat: {
    width: '100%',
  },
  conversations: {
    minWidth: '23%',
    border: '1px solid #D0D8DC',
    borderRadius: '5px',
    height: 'max-content',
  },
  conversationWrapper: {
    padding: '0 10px',
    background: '#FFFFFF',
    cursor: 'pointer',
    '&:hover': {
      background: '#0000000a',
    },
  },
  conversationWrapperActive: {
    background: '#1E60E1 !important',
    '& div': {
      color: 'white !important',
    },
  },
  conversation: {
    height: 80,
    display: 'flex',
    alignItems: 'center',
  },
  img: {
    height: 40,
    width: 40,
    borderRadius: '100%',
    backgroundImage: `url(${oppiziLogo})`,
    backgroundSize: '80%',
    backgroundRepeat: 'no-repeat',
    border: '1px solid #ef4763',
    backgroundPosition: 'center',
  },
  textWrapper: {
    marginLeft: 10,
    width: '77%',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  message: {
    fonSize: 14,
    color: '#c4c4c4',
  },
  date: {
    width: '100%',
    textAlign: 'right',
    fontSize: 12,
  },
  scroll: {
    overflowY: 'scroll',
    height: '100%',
    maxHeight: 'calc(90vh - 130px)',
  },
}
